import { LocaleKeys } from '../../../../locale/translation-types'

export enum TransportModeEnum {
  BUS_PASS = 'BUS_PASS',
  WALK = 'WALK',
  EXTRA_BUS_OR_TRAIN = 'EXTRA_BUS_OR_TRAIN'
}

export const transportModeEnumMapping: Record<TransportModeEnum, LocaleKeys> = {
  [TransportModeEnum.BUS_PASS]: 'transport.mode.enum.BUS_PASS',
  [TransportModeEnum.WALK]: 'transport.mode.enum.WALK',
  [TransportModeEnum.EXTRA_BUS_OR_TRAIN]: 'transport.mode.enum.EXTRA_BUS_OR_TRAIN'
}
